import { defineComponent as o, ref as i, openBlock as f, createBlock as m, unref as u, mergeProps as d, withCtx as s, renderSlot as a } from "vue";
import c from "./ghl-ui.es153.js";
const p = o({
  name: "UIForm"
}), y = o({
  ...p,
  props: {
    rules: {
      type: Object
    },
    inline: {
      type: Boolean,
      default: !1
    },
    model: {
      type: [String, Object]
    },
    id: {
      type: String,
      required: !0
    }
  },
  setup(e, { expose: n }) {
    const r = i();
    function l() {
      return r.value;
    }
    return n({ getForm: l }), (t, g) => (f(), m(u(c), d({ id: e.id }, t.$attrs, {
      rules: e.rules,
      model: e.model,
      inline: e.inline,
      ref_key: "formRef",
      ref: r
    }), {
      default: s(() => [
        a(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "rules", "model", "inline"]));
  }
}), B = y;
export {
  B as default
};
